import { render, staticRenderFns } from "./ErrorDrawer.vue?vue&type=template&id=d36e10d4&scoped=true&lang=pug"
import script from "./ErrorDrawer.vue?vue&type=script&lang=js"
export * from "./ErrorDrawer.vue?vue&type=script&lang=js"
import style0 from "./ErrorDrawer.vue?vue&type=style&index=0&id=d36e10d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36e10d4",
  null
  
)

export default component.exports